import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { ErrorMessage, SuccessMessage } from '../../../components';
import { setLoading } from '../../../store/slices/UI';

export const initModal = {
  initContent: null,
  initVisible: false,
  initType: 'ok',
  initsize: 'sm',
  isCloseVisible: true,
  initAcceptHandler: () => {},
  initCanceltHandler: () => {}
};

const { initContent, initVisible, initType, initsize, initAcceptHandler, initCanceltHandler } = initModal;

const useModal = () => {
  const [content, setContent] = useState(initContent);
  const [visible, setVisible] = useState(initVisible);
  const [isCloseVisible, setIsCloseVisible] = useState(initVisible);
  const [type, setType] = useState(initType);
  const [size, setSize] = useState(initsize);
  const [acceptHandler, setAcceptHandler] = useState(initAcceptHandler);
  const [cancelHandler, setCancelHandler] = useState(initCanceltHandler);

  // Redux
  const dispatch = useDispatch();

  const showModal = useCallback(
    (
      content,
      isCloseVisible = true,
      size = initsize,
      type = initType,
      acceptHandler = initAcceptHandler,
      cancelHandler = initCanceltHandler
    ) => {
      dispatch(setLoading(false));
      setContent(content);
      setVisible(true);
      setIsCloseVisible(isCloseVisible);
      setType(type);
      setSize(size);
      setAcceptHandler(acceptHandler);
      setCancelHandler(cancelHandler);
    },
    [dispatch]
  );

  const hideModal = useCallback(() => {
    setContent(null);
    setVisible(false);
  }, []);

  const showSuccess = useCallback(
    ({ title, description, callback = undefined }) => {
      let currentCallback = hideModal;
      if (callback) {
        currentCallback = () => {
          callback();
          hideModal();
        };
      }
      dispatch(setLoading(false));
      setContent(<SuccessMessage title={title} description={description} callback={currentCallback} />);
      setVisible(true);
      setType(initType);
      setSize(initsize);
      setAcceptHandler(initAcceptHandler);
      setCancelHandler(initCanceltHandler);
    },
    [dispatch, hideModal]
  );

  const showError = useCallback(
    ({ title, description, callback = undefined, buttons }) => {
      let currentCallback = hideModal;
      if (callback) {
        currentCallback = () => {
          callback();
          hideModal();
        };
      }
      dispatch(setLoading(false));
      setContent(<ErrorMessage title={title} description={description} callback={currentCallback} />);
      setVisible(true);
      setType(initType);
      setSize(initsize);
      setAcceptHandler(initAcceptHandler);
      setCancelHandler(initCanceltHandler);
    },
    [dispatch, hideModal]
  );

  return {
    content: content,
    visible: visible,
    type: type,
    size: size,
    acceptHandler: acceptHandler,
    cancelHandler: cancelHandler,
    showModal: showModal,
    hideModal: hideModal,
    showSuccess: showSuccess,
    showError: showError,
    isCloseVisible
  };
};

export default useModal;
